module.exports = __webpack_public_path__ + "img/folder.c2bfabc2.svg";